<script lang="ts" setup>
import { ElFormItem, ElAlert } from "element-plus";
import { useI18n } from "vue-i18n";

export interface Props {
  label: string;
}

defineProps<Props>();

const { t } = useI18n();
</script>

<template>
  <el-form-item :label="label">
    <el-alert
      type="info"
      show-icon
      :title="t('visitors.fields.fieldNotSupported')"
      :closable="false"
    />
  </el-form-item>
</template>
